import processTopComments from './top-comments'

export { processTopComments as process }
